import WebLLCRESTApi from "../api/api";
import UUID from "../util/uuid";
import AddStringList from "./AddStringList.vue";
import { v1TierDefaults, v2TierDefaults } from "../packages/Packages.js";
import moment from 'moment';
import $ from 'jquery';

export default {
  name: "PackageData",
  
  created() {
    this.api = new WebLLCRESTApi("Campaigns", this.$router);
    this.apiExternalServices = new WebLLCRESTApi("External-Services", this.$router);
  },
  
  props: {
      clientId: {
          type: String,
      },
      viewObj: {
          type: Object,
      }
  },
  
  data() {
    return {
      packageVersion: "v2",
      clientName: "",
      zohoAccountReview: "",
      selectedTab: "settings",
      selectedClientType: "",
      selectedTier: "",
      selectedLevel: "",
      tiers: { "v1": v1TierDefaults, "v2": v2TierDefaults },
      txtName: "",
      txtStartDate: "",
      txtEndDate: "",
      chkHasEndDate: true,
      chkFilterKeyword: "initial",
      filterKeywordDate: "false",
      packageControls: [],
      keywords: [],
      domains: [],
      campaignSentMonths: [],
      lockFields: false,
      hasErrors: false,
      errorFields: {},
      allTiersMatch: true,
      savingSpinner: false,
    }
  },
  
  methods: {
    
    checkRequiredFields() {
      var isOk = true;
      
      const fieldList = [
        { field: this.selectedClientType, name: "selectedClientType" },
        { field: this.selectedTier, name: "selectedTier" },
        { field: this.selectedLevel, name: "selectedLevel" },
        { field: this.txtName, name: "txtName" },
        { field: this.txtStartDate, name: "txtStartDate" },
        { field: this.txtEndDate, name: "txtEndDate", onlyIf: this.chkHasEndDate }
      ];
      
      for(const control of this.packageControls) {
        const controlName =
          (control.type == "keywordaddt" ? control.id + "-addt" :
          control.type == "keywordrelated" ? control.id + "-related" : 
          control.id);
        
        fieldList.push({
          field: control.value,
          name: controlName
        });
      }
      
      this.errorFields = {};
      
      for(var index=0; index<fieldList.length; index++) {
        const entry = fieldList[index];
        const onlyIf = (entry.onlyIf === undefined ? true : entry.onlyIf);
        
        if(!this.isEntryFilled(entry.field) && onlyIf) {
          this.errorFields[entry.name] = "is-invalid";
          isOk = false;
        }
      }
      
      // check the account review URL is correct
      if(this.zohoAccountReview && this.zohoAccountReview.indexOf("https://crm.zoho.com/crm/org41481355/tab/CustomModule33/") !== 0) {
        this.errorFields["zohoAccountReview"] = "is-invalid";
        isOk = false;
      }
      
      return isOk;
    },
    
    isEntryFilled(entry) {
      return entry !== "" && entry !== undefined;
    },
    
    async onAddPackage() {
      if(!this.checkRequiredFields()) {
        this.hasErrors = true;
        return false;
      }
      else {
        this.hasErrors = false;
      }
      
      this.savingSpinner = true;
      
      const newPackageDetails = {
        id: UUID.genUuidV4(),
        name: this.txtName,
        startDate: this.txtStartDate + "T00:00:00Z",
        hasEndDate: this.chkHasEndDate,
        endDate: (this.chkHasEndDate ? this.txtEndDate + "T00:00:00Z" : null),
        data: JSON.stringify(this.getNewPackageDetails()),
        clientId: this.clientId
      };
      
      if(this.viewObj.operation === "new") {
        const res = await this.api.addData(newPackageDetails);
        
        if(res.status == 200 || res.status == 204) {
          const json = await res.json();
          await this.updateExternalServices(newPackageDetails.id);
          
          this.$emit('added', json.id);
          $('#modal-add-package-data').modal('toggle');
        }
        else {
          alert("Server error");
        }
      }
      else {
        const campaignId = this.viewObj.id;
        delete newPackageDetails["id"];
        
        const res = await this.api.updateData(campaignId, newPackageDetails);
        await this.updateExternalServices(campaignId);
        
        if(res.status == 200 || res.status == 204) {
          this.$emit('added', campaignId);
          $('#modal-add-package-data').modal('toggle');
        }
        else {
          alert("Server error");
        }
      }
      
      this.savingSpinner = false;
    },
    
    async updateExternalServices(campaignId) {
      const currentExternalServices = await this.apiExternalServices.getData(null, {
        where: {
          service: "zoho",
          campaignId: campaignId
        }
      });
      
      if(this.zohoAccountReview) {
        const zohoId = this.zohoAccountReview.replace("https://crm.zoho.com/crm/org41481355/tab/CustomModule33/", "").split("/")[0].trim();
        
        const matchingServices = currentExternalServices.filter((external) => external.connectId === zohoId);
        const nonMatchingServices = currentExternalServices.filter((external) => external.connectId !== zohoId);
        
        for(const externalService of nonMatchingServices) {
          await this.apiExternalServices.deleteData(externalService.id);
        }
        
        if(matchingServices.length == 0) {
          return await this.apiExternalServices.addData({
            service: "zoho",
            connectId: zohoId,
            metaData: "",
            campaignId: campaignId
          });
        }
      }
      else {
        for(const externalService of currentExternalServices) {
          await this.apiExternalServices.deleteData(externalService.id);
        }
      }
    },
    
    getNewPackageDetails() {
      const packageDetails = {
        packageVersion: this.packageVersion,
        clientType: this.selectedClientType,
        tier: this.selectedTier,
        level: this.selectedLevel,
        keywords: this.keywords,
        domains: this.domains,
        sentToClient: this.campaignSentMonths.map((item) => {
          return {
            sender: item.sender,
            time: item.time
          };
        })
      };
      
      for(const control of this.packageControls) {
        if(control.type == "keywords") {
          packageDetails[control.id] = {
            num: control.value,
            addt: "",
            related: ""
          };
        }
        else if(control.type == "keywordaddt") {
          packageDetails[control.id].addt = control.value;
        }
        else if(control.type == "keywordrelated") {
          packageDetails[control.id].related = control.value;
        }
        else if(control.type == "checkbox") {
          packageDetails[control.id] = control.value.toString() == "true";
        }
        else {
          packageDetails[control.id] = control.value;
        }
      }
      
      return packageDetails;
    },
    
    saveKeywordList(newKeywords) {
      this.keywords = newKeywords.sort(this.sortKeyword);
    },
    
    sortKeyword(a, b) {
      const keywordA = (typeof a == "string" ? a : a.str);
      const keywordB = (typeof b == "string" ? b : b.str);
      
      if(keywordA < keywordB) {
        return -1;
      }
      else if(keywordA > keywordB) {
        return 1;
      }
      else {
        return 0;
      }
    },
    
    saveDomainList(newDomains) {
      this.domains = newDomains.sort();
    },
    
    selectPackage(initFields) {
      if(initFields) {
        const packageVersion = (initFields.packageVersion ? initFields.packageVersion : "v1");
        const clientType = (initFields.clientType ? initFields.clientType : "default");
        const tier = (initFields.tier ? initFields.tier : initFields.name);
        const level = (initFields.level ? initFields.level : "1");
        
        if(this.packageVersion !== packageVersion) {
          this.packageVersion = packageVersion;
        }
        if(this.selectedClientType !== clientType) {
          this.selectedClientType = clientType;
        }
        if(this.selectedTier !== tier) {
          this.selectedTier = tier;
        }
        if(this.selectedLevel !== level) {
          this.selectedLevel = level;
        }
      }
    },
    
    getDefaultControlValue(controlId, defControl, initFields) {
      if(initFields) {
        if(defControl.type == "keywords") {
          return {
            num: (initFields[controlId].num ? initFields[controlId].num : initFields[controlId]),
            addt: (initFields[controlId].addt ? initFields[controlId].addt : initFields.packageAddtKeywords),
            related: (initFields[controlId].related ? initFields[controlId].related : defControl.related)
          };
        }
        else if(defControl.type == "checkbox") {
          return (initFields[controlId] && (initFields[controlId].toString() == "true" || initFields[controlId].toString() == "yes") ? true : false);
        }
        else if(defControl.type == "combo") {
          return initFields[controlId];
        }
        else {
          return initFields[controlId];
        }
      }
      else {
        if(defControl.type == "keywords") {
          return {
            num: defControl.value,
            addt: defControl.addt,
            related: defControl.related
          };
        }
        else if(defControl.type == "checkbox") {
          return defControl.value;
        }
        else if(defControl.type == "combo") {
          return defControl.value;
        }
        else {
          return defControl.value;
        }
      }
    },
    
    refreshPackageControls(initFields) {
      // ensure the correct package tier/level is selected
      if(initFields) {
        this.selectPackage(initFields);
      }
      
      // build our control list
      const arrControls = [];
      const defControlList = this.tierDefaults;
      
      for(const controlId in defControlList) {
        const defControl = defControlList[controlId];
        const defValue = this.getDefaultControlValue(controlId, defControl, initFields);
        
        if(defControl.type == "keywords") {
          arrControls.push({
            id: controlId,
            text: "Number of Keywords",
            type: "keywords",
            min: defControl.min,
            max: defControl.max,
            value: defValue.num
          });
          
          arrControls.push({
            id: controlId,
            text: "Addt Unique Keywords",
            type: "keywordaddt",
            value: defValue.addt
          });
          
          arrControls.push({
            id: controlId,
            text: "Addt Related Keywords",
            type: "keywordrelated",
            value: defValue.related
          });
        }
        else if(defControl.type == "checkbox") {
          const value = defValue.toString().toLowerCase();
          
          arrControls.push({
            id: controlId,
            text: defControl.text,
            type: defControl.type,
            value: (value == "true" || value == "yes" ? "true" : "false")
          });
        }
        else if(defControl.type == "combo") {
          const options = defControl.options.map((option) => {
            return {
              id: option,
              name: this.tierTextMapping[controlId + "-" + option]
            };
          });
          
          arrControls.push({
            id: controlId,
            text: defControl.text,
            type: defControl.type,
            options: options,
            value: defValue.toString()
          });
        }
        else if(defControl.type) {
          arrControls.push({
            id: controlId,
            text: defControl.text,
            type: defControl.type,
            min: defControl.min,
            max: defControl.max,
            options: defControl.options,
            value: defValue
          });
        }
      }
      
      this.packageControls = arrControls;
    },
    
    getZohoAccountReviewFromServices(externalServices) {
      if(externalServices) {
        const zohoServices = externalServices.filter((external) => external.service == "zoho")
        
        if(zohoServices.length > 0) {
          return "https://crm.zoho.com/crm/org41481355/tab/CustomModule33/" + zohoServices[0].connectId;
        }
        else {
          return "";
        }
      }
      else {
        return "";
      }
    },
    
    onResetTierDefaults() {
      // this is for the button click vs the tier drop down changing
      this.refreshPackageControls(null);
    }
  },
  
  computed: {
    tierDefaults() {
      if(this.tiers[this.packageVersion] &&
          this.tiers[this.packageVersion][this.selectedClientType] &&
          this.tiers[this.packageVersion][this.selectedClientType][this.selectedTier] &&
          this.tiers[this.packageVersion][this.selectedClientType][this.selectedTier].levels[this.selectedLevel]) {
        return this.tiers[this.packageVersion][this.selectedClientType][this.selectedTier].levels[this.selectedLevel];
      }
      else {
        return {};
      }
    },
    
    tierMatch() {
      const matches = {
          allTiersMatch: true
        };
      
      for(const control of this.packageControls) {
        const defControlValue = this.getDefaultControlValue(control.id, this.tierDefaults[control.id], null);
        
        if(control.type == "keywords") {
          matches[control.id] = control.value == defControlValue.num;
        }
        else if(control.type == "keywordaddt") {
          matches[control.id + "-addt"] = control.value == defControlValue.addt;
        }
        else if(control.type == "keywordrelated") {
          matches[control.id + "-related"] = control.value == defControlValue.related;
        }
        else if(control.type == "checkbox") {
          matches[control.id] = (control.value.toString() == "true") == defControlValue;
        }
        else {
          matches[control.id] = control.value == defControlValue;
        }
      }
      
      for(const controlId in matches) {
        if(!matches[controlId]) {
          matches.allTiersMatch = false;
        }
      }
      
      return matches;
    },
    
    tierTextMapping() {
      if(this.tiers[this.packageVersion]) {
        return this.tiers[this.packageVersion].textMapping;
      }
      else {
        return {};
      }
    },
    
    availableClientTypes() {
      if(this.tiers[this.packageVersion]) {
        const clientTypes = [];
        
        for(const typeId in this.tiers[this.packageVersion]) {
          if(this.tiers[this.packageVersion][typeId].name) {
            clientTypes.push({
              id: typeId,
              name: this.tiers[this.packageVersion][typeId].name
            });
          }
        }
        
        return clientTypes;
      }
      else {
        return [];
      }
    },
    
    availableTiers() {
      if(this.tiers[this.packageVersion] && this.tiers[this.packageVersion][this.selectedClientType]) {
        const tiers = [];
        
        for(const tierId in this.tiers[this.packageVersion][this.selectedClientType]) {
          if(this.tiers[this.packageVersion][this.selectedClientType][tierId].name) {
            tiers.push({
              id: tierId,
              name: this.tiers[this.packageVersion][this.selectedClientType][tierId].name
            });
          }
        }
        
        return tiers;
      }
      else {
        return [];
      }
    },
    
    availableLevels() {
      if(this.tiers[this.packageVersion] && this.tiers[this.packageVersion][this.selectedClientType] && this.tiers[this.packageVersion][this.selectedClientType][this.selectedTier]) {
        const tier = this.tiers[this.packageVersion][this.selectedClientType][this.selectedTier];
        const levels = [];
        
        for(const levelId in tier.levels) {
          levels.push(levelId);
        }
        
        return levels;
      }
      else {
        return [];
      }
    }
  },
  
  watch: {
    packageVersion() {
      if(!this.lockFields) {
        this.selectedClientType = "";
      }
    },
    
    selectedClientType() {
      if(!this.lockFields) {
        this.selectedTier = "";
      }
    },
    
    selectedTier(to, from) {
      if(!this.lockFields) {
        if(!this.txtName || this.txtName == this.clientName + " - " + from) {
          this.txtName = this.clientName + " - " + to;
        }
        
        this.selectedLevel = "";
      }
    },
    
    selectedLevel() {
      if(!this.lockFields) {
        this.refreshPackageControls(null);
      }
    },
    
    chkFilterKeyword(to) {
      if(to == "initial") {
        this.filterKeywordDate = "false";
      }
      else if(to == "mid") {
        this.filterKeywordDate = "true";
      }
      else {
        this.filterKeywordDate = "all";
      }
    },
    
    async viewObj() {
      this.errorFields = {};
      this.hasErrors = false;
      
      // refresh the client name
      const clientApi = new WebLLCRESTApi("Clients", this.$router);
      
      const client = await clientApi.getData(this.clientId);
      this.clientName = client.firstName + " " + client.lastName;
      
      // clear any fields out
      if(this.viewObj == "new" || this.viewObj.operation == "new") {
        this.zohoAccountReview = "";
        this.packageVersion = "v2";
        this.selectedClientType = "";
        this.selectedTier = "";
        this.selectedLevel = "";
        this.txtName = "";
        this.txtStartDate = "";
        this.chkHasEndDate = true;
        this.txtEndDate = "";
        
        this.refreshPackageControls(null);
        
        this.keywords = [];
        this.domains = [];
        this.campaignSentMonths = [];
      }
      else {
        if(this.viewObj && this.viewObj.data) {
          this.lockFields = true;
          const tierInfo = JSON.parse(this.viewObj.data);
          
          this.zohoAccountReview = this.getZohoAccountReviewFromServices(this.viewObj.externalServices);
          this.txtName = this.viewObj.name;
          this.txtStartDate = moment.utc(this.viewObj.startDate).format("YYYY-MM-DD");
          this.chkHasEndDate = this.viewObj.hasEndDate;
          this.txtEndDate = (this.viewObj.endDate ? moment.utc(this.viewObj.endDate) : moment()).format("YYYY-MM-DD");
          
          this.keywords = (tierInfo.keywords ? tierInfo.keywords : []);
          this.domains = (tierInfo.domains ? tierInfo.domains : []);
          
          this.campaignSentMonths = (tierInfo.sentToClient ?
            tierInfo.sentToClient
              .map((item, monthNum) => {
                if(item) {
                  return {
                    monthNum: monthNum,
                    sender: item.sender,
                    time: item.time,
                    formattedDate: new Date(item.time).toLocaleString()
                  };
                }
                else {
                  return false;
                }
              })
              .filter((item) => !!item) :
            []);
          
          this.refreshPackageControls(tierInfo);
          
          // release field lock once everything has been filled
          this.$nextTick(() => { this.lockFields = false; });
        }
      }
    },
  },
  
  components: {
    AddStringList
  }
}



// WEBPACK FOOTER //
// ./src/components/PackageData.js